import React from 'react';

import { HomeContentEntity } from '../../domain/entities/HomeContentEntity';

import EnterpriseGrowthCardCmp from './EnterpriseGrowthCardCmp';

interface EnterpriseBannerCmpProps {
  page_data: HomeContentEntity;
}

function EnterpriseBannerCmp({
  page_data,
}: EnterpriseBannerCmpProps): React.ReactElement {
  return (
    <EnterpriseGrowthCardCmp
      section_data={page_data.enterprise_home_section}
    />
  );
}

export default EnterpriseBannerCmp;
